<div class="sub-navigation container" style="padding-top: 30px" *ngIf="showSubNav$ | async">
  <div class="d-flex align-items-start justify-content-between">
    <div *ngIf="breadcrumbs$ | async as breadcrumbs">
      <div class="sub-navigation-breadcrumb" *ngIf="breadcrumbs.length > 1">
        <nk-sub-navigation-breadcrumb [breadcrumbs]="breadcrumbs"></nk-sub-navigation-breadcrumb>
      </div>
    </div>
    @if (pageActions(); as actionsTemplate) {
      <ng-container [ngTemplateOutlet]="actionsTemplate"></ng-container>
    }
  </div>
  <nk-tab-menu class="d-block mt-1" *ngIf="tabs$ | async as tabs" [tabs]="tabs"></nk-tab-menu>
</div>
